export const BACK_OFFICE_API_APPLICATIONS_CONTROLLER_END_POINTS = {
  CONTROLLER_PATH: "applications",
  FILTER_PATH: "/filter",
  MATCHING_PATH: "/matching",
  CALCULATIONS_PATH: "/calculations",
  CALCULATIONS_BY_ROUTE_PATH: "/calculations/by-route",
  WAIT_FOR_UPDATE_PATH: "/wait-for-update",
  QUOTES_SIMPLE: "/quotes-simple",
};
